// Components==============
import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { motion } from 'framer-motion';
import { useRedux } from 'hooks/useRedux';
import { useRootModal } from 'hooks/useRootModal';
import { useTranslate } from 'hooks/useTranslate';
import { GrowthPortfolioContext } from 'pages/Growth/GrowthPortfolio/GrowthPortfolio';
import React, { useContext } from 'react';
import AddDreamModal from '../../../Dreams/AddDreamModal/AddDreamModal';
import './Dreams.module.scss';
// =========================

const parent = {
  mount: {
    transition: { staggerChildren: 0.1, delayChildren: 0.5 },
  },
  whileHover: { scale: 1.03 },
  initial: { scale: 1 },
  whileTap: { scale: 0.97 },
};

const child = {
  mount: { opacity: 1 },
  initial: { opacity: 0 },
};

const opacityChild = {
  mount: { opacity: 0.6 },
  initial: { opacity: 0 },
};

export default function Dreams() {
  const dreams = useRedux((state) =>
    state.dream?.entities.allIds
      .map((id) => state.dream?.entities.byId[id])
      .filter((dream) => !dream?.is_public)
  );

  const { setSelected } = useContext(GrowthPortfolioContext);
  const { setModal } = useRootModal();

  const translate = useTranslate();

  const dream1 = dreams?.[0];
  const dream2 = dreams?.[1];
  const dream3 = dreams?.[2];

  return (
    <div styleName="box">
      <div styleName="wrapper">
        <motion.div
          variants={parent}
          animate="mount"
          whileHover="whileHover"
          initial="initial"
          whileTap="whileTap"
          onClick={() => setSelected('dream.terms.dreams')}
        >
          <motion.div variants={opacityChild} styleName="small-circle-2" />
          <motion.div variants={opacityChild} styleName="small-circle-1" />
          <motion.h1 variants={child}>{dreams?.length}</motion.h1>
          {!!dream1?.image && (
            <motion.img
              variants={child}
              src={dream1?.image}
              alt={dream1?.name}
              styleName="big-dream"
            />
          )}
          {!!dream2?.image && (
            <motion.img
              variants={child}
              src={dream2?.image}
              alt={dream2?.name}
              styleName="medium-dream"
            />
          )}
          {!!dream3?.image && (
            <motion.img
              variants={child}
              src={dream3?.image}
              alt={dream3?.name}
              styleName="small-dream"
            />
          )}
          <motion.div variants={child} styleName="plus-outer">
            <div
              styleName="plus-inner"
              onClick={(e) => {
                e.stopPropagation();
                setModal(<AddDreamModal />);
              }}
            >
              <FontAwesomeIcon icon={faPlus} />
            </div>
          </motion.div>
        </motion.div>

        <h3>{translate('dream.terms.dreams')}</h3>
      </div>
    </div>
  );
}
